import { useEffect, useState } from "react";
import config from "../../../config";
import {
  componentCheckSize,
  componentResize,
  createMarkup,
} from "../../../utils/helperServices";
import CarouselButton from "../../atoms/buttons/carouselButton/CarouselButton";
import {
  Col,
  Container,
  CustomContainer,
  OwlCarousel,
  Row,
} from "../../atoms/DependencyHelper";
import UpgradeCard from "../upgradeCard/UpgradeCard";
import * as Analytics from "../../../services/analyticsUtag";

import styles from "./UpgradeCarousel.module.scss";

const UpgradeCarousel = (props) => {
  const [previousNavClass, setPreviousNavClass] = useState("");
  const [nextNavClass, setNextNavClass] = useState("");
  const [customCSS, setCustomCSS] = useState({});
  const isDesktop = componentCheckSize() > 992;
  const isMobile = componentCheckSize() < 576;

  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const [showAccordion, setShowAccordion] = useState(false);
  let upgradeCarousel;

  useEffect(() => {
    setShowAccordion(true);
  }, []);

  useEffect(() => {
    if (isDesktop && props?.positionX >= 0) {
       setCustomCSS({
          marginLeft : `${props.positionX + 15}px!important`,
          paddingLeft: "0!important"
       });
    }
  }, [isDesktop, props?.positionX]);

  const next = () => {
    if (upgradeCarousel) {
      upgradeCarousel.next(600);
    }
  };
  const prev = () => {
    if (upgradeCarousel) {
      upgradeCarousel.prev(600);
    }
  };
  const carouselOptions = {
    nav: false,
    autoplay: false,
    animateIn: "animate__fadeIn",
    margin: isDesktop ? 32 : 16,
    autoWidth: true,
    lazyLoad: true,
    dotsClass: false,
    dotClass: false,
    slideBy: 1,
    dots: false,
    loop: false,
    center: false,
    responsive: {
      0: {
        slideBy: 1,
      },
    },
  };

  const events = {
    onInitialized: function (event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslated: function (event) {
      toggleCarouselNavDisabled(event);
    },
  };

  function toggleCarouselNavDisabled(event) {
    const index = event.item.index;
    const minimum = 0;
    const maximum = event.item.count;

    let previousNav = index <= minimum ? "disabled" : "";
    let nextNav =
        index +
        carouselOptions.responsive[event.relatedTarget._breakpoint].slideBy >=
        maximum
            ? "disabled"
            : "";

    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  const handleAccordion = () => {
    setShowAccordion(!showAccordion);
    if(!showAccordion){
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: `${Analytics.getPageName()}: why upgrade online`,
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "page_site_section_lvl_1",
          "page_site_section_lvl_2",
          "page_site_section_lvl_3",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
      })
    }
  };

  return (
      <CustomContainer className={styles["carousel-container"]}>
        {!isDesktop && (
            <Container
                className={styles["mobile-accordion"]}
                onClick={handleAccordion}
            >
              <CustomContainer className={styles["upgrade-online-heading"]}>{"Why upgrade online"}</CustomContainer>
              <CustomContainer className={styles["upgrade-accordion-symbol"]}>
                {!showAccordion && (
                    <img
                        height={9.5}
                        width={18}
                        src={`${imagePrefix}/assets/images/chevron-down-black.svg`}
                    />
                )}
                {showAccordion && (
                    <img
                        height={9.5}
                        width={18}
                        src={`${imagePrefix}/assets/images/chevron-up-black.svg`}
                    />
                )}
              </CustomContainer>
            </Container>
        )}

        {/* { showAccordion && ( // TODO: Investigate why this crashes the project on Edge browser.
            <CustomContainer className={styles["upgrade-carousel-container"]}>
              <OwlCarousel
                  ref={(c) => (upgradeCarousel = c)}
                  options={carouselOptions}
                  events={events}
              >
                {props.carouselData && props.carouselData.cards.map((_slide, i) => (
                    <div key={i} className={`${styles["upgrade-slide"]} ${i==0 && styles["first-card"]}`}>
                      <Container
                          id={_slide.id}
                          data-cms-title={_slide.title ? _slide.title : _slide.heading}
                          className={styles["card-container"]}
                          css={isDesktop && customCSS}
                      >
                        <UpgradeCard cardData= {_slide} />
                      </Container>
                    </div>
                ))}
              </OwlCarousel>
              {isDesktop && (
                  <div className={`custom-owl--nav`}>
                    <CarouselButton
                        prev
                        handleClick={prev}
                        className={`${previousNavClass} ${styles["prev-arrow"]}`}
                        btnTheme={"light"}
                        id={"upgrade_arrowNxtBtn"}
                    />
                    <CarouselButton
                        next
                        handleClick={next}
                        className={`${nextNavClass} ${styles["next-arrow"]}`}
                        btnTheme={"light"}
                        id={"upgrade_arrowBackBtn"}
                    />
                  </div>
              )}
            </CustomContainer>
        )} */}
      </CustomContainer>
  );
};

export default UpgradeCarousel;
